<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openStorage="openStorage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @export="exportData"
        @reset="resetPage"
        @batchChangeLocation="batchChangeLocation"
        @batchSampleListing="batchSampleListing"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <storage
      ref="storage"
      :treeData="treeData"
      @refresh="refresh()"
      @clearSelect="clearCheckboxRow"
    />
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :title="$l('INDEX.dialog_title_select_export_template') || '选择导出模版'"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
      @confirmClose="confirmClose"
    />

    <el-dialog
      v-if="dialogVisible"
      show-close
      :visible.sync="dialogVisible"
      width="500px"
      :title="$l('dialog_find_location') || '查询库位号'"
      :close-on-click-modal="false"
      :before-close="() => close()"
      destroy-on-close
      append-to-body
    >
      <el-form
        ref="form"
        :model="formData"
        label-width="120px"
        onsubmit="return false"
        :rules="rules"
        style="margin-top: 30px;margin-bottom: 30px;"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item
              :label="$l('form_lable_location') || '纸箱库位号'"
              prop="locationNo"
            >
              <el-input
                v-model="formData.locationNo"
                size="medium"
                clearable
                ref="mark"
                :placeholder="
                  $l('tip_please_input_location') || '请输入纸箱库位号'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
    <SampleListing
      :visible.sync="visibleSampleListing"
      :close="close"
      :reload="reload"
      :treeData="treeData"
    />
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import Storage from '../storage'
import validate from '@/libs/util.validate'
import ChooseTemplate from '@/views/backstage/components/choose-template'
import SampleListing from '../sampleListing'
export default {
  components: {
    PageHeader,
    PageMain,
    Storage,
    ChooseTemplate,
    SampleListing,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      visibleSampleListing: false,
      treeData: [],
      formData: { locationNo: '' },
      dialogVisible: false,
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'admin-sampleLocation',
        exportCheckUrl: '',
        exportParams: {
          locationNo: '',
        },
      },
      rules: {
        locationNo: [
          {
            required: true,
            message: this.$l('tip_please_input_location') || '请输入纸箱库位号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .stockSampleLocationListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async batchSampleListing() {
      const res = await this.$api.warehouseTreeApi()
      this.treeData = res.body.data
      this.visibleSampleListing = true
    },
    async batchChangeLocation() {
      let data = await this.$refs.main.batchChangeLocation()
      if (data === null || data === undefined || data.length <= 0) {
        return
      }
      this.openStorage(data)
    },
    refresh() {
      this.reload()
    },
    openStorage(listCode) {
      this.$api
        .warehouseTreeApi()
        .then((res) => {
          this.treeData = res.body.data
          this.$refs.storage.load(listCode)
        })
        .catch(() => {})
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
    exportData() {
      this.dialogVisible = true
    },

    confirmClose() {
      this.chooseTemplateOptions.visible = false
      this.close()
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.$api
        .stockSampleLocationExportCheckApi({
          locationNo: this.formData.locationNo,
        })
        .then((res) => {
          if (res.status === 200) {
            this.chooseTemplateOptions = {
              visible: true,
              templateGroup: 'admin-sampleLocation',
              exportCheckUrl: '',
              exportParams: {
                locationNo: this.formData.locationNo,
              },
            }
          }
        })
        .catch(() => {})
    },
    close() {
      this.dialogVisible = false
      this.visibleSampleListing = false
      this.formData = {}
    },
  },
}
</script>
